import { ReactNode } from 'react'

export const PaymentPendingRoutingTableRow = ({ icon, subtitle, infoData }: { icon: string; subtitle: string; infoData: string | ReactNode }) => {
  return (
    <div className="table-row-container">
      <div className="left-content">
        <div className="icon-container">
          <img
            src={icon}
            alt="table-row-icon"
          />
        </div>
        <div className="table-row-content-subtitle">{subtitle}</div>
      </div>
      <div className="right-content">
        <div
          style={{ width: '100%' }}
          className="table-row-info-data"
        >
          <div
            style={{ width: '100%' }}
            className="info-data-general-text"
          >
            {infoData}
          </div>
        </div>
      </div>
    </div>
  )
}
